import { datadogLogs } from "@datadog/browser-logs";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { bijectionOptional } from "@redotech/util/bijection";
import { storeTransform } from "@redotech/util/store";
import { StringFormat } from "@redotech/util/string-format";
import { localStore } from "@redotech/web-util/storage";
import { useNavigate } from "react-router-dom";

export type ScanMode = typeof ScanMode.PRINT | typeof ScanMode.VERIFY_PRINT;

export namespace ScanMode {
  export const PRINT = "print" as const;
  export const VERIFY_PRINT = "verify_print" as const;
}

export const scanModeFormat: StringFormat<ScanMode> = {
  read(value: string): ScanMode {
    switch (value) {
      case ScanMode.PRINT:
        return ScanMode.PRINT;
      case ScanMode.VERIFY_PRINT:
        return ScanMode.VERIFY_PRINT;
      default:
        throw new Error(`Invalid scan mode: ${value}`);
    }
  },
  write(value: ScanMode): string {
    return value;
  },
};

export const scanModeStore = storeTransform(
  localStore("redo.scanMode"),
  bijectionOptional(scanModeFormat),
);

export const scanModeOptions: RedoListItem<ScanMode>[] = [
  {
    id: ScanMode.VERIFY_PRINT,
    type: "text",
    text: "Verify and print",
    value: ScanMode.VERIFY_PRINT,
  },
  { id: ScanMode.PRINT, type: "text", text: "Print", value: ScanMode.PRINT },
];

export const verifyForm = groupInput({
  barcode: input<string>({ validator: nonEmptyValidator }),
});

export const useNavigateToScanStart = () => {
  const team = useRequiredContext(TeamContext);
  const navigate = useNavigate();

  return () => {
    datadogLogs.logger.info("Navigating to scan start", { teamId: team._id });
    navigate(`/stores/${team._id}/order-management/outbound-labels/scan`);
  };
};
